import React from 'react';
import PropTypes from 'prop-types';

export default function ToastNotifications({ toasts }) {
  if (toasts.length === 0) return null;

  return (
    <div className="score-stack">
      {toasts.map((toast) => (
        <div key={toast.id} className="score-toast">
          Bullseye! <span>{toast.label}</span>
        </div>
      ))}
    </div>
  );
}

ToastNotifications.propTypes = {
  toasts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
};

ToastNotifications.defaultProps = {
  toasts: [],
};

